export function chooseFont(...objs: any[]): string {
  const str = JSON.stringify(objs);

  // Japanese: Hiragana, Katakana, half-width Katakana
  const japaneseRegex = /[\u3040-\u309F\u30A0-\u30FF\u31F0-\u31FF\uFF66-\uFF9F]/;
  // Korean: Hangul syllables & Jamo
  const koreanRegex = /[\uAC00-\uD7AF\u1100-\u11FF]/;
  // Chinese: CJK Unified Ideographs + extensions
  const chineseRegex = /[\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]/;
  // Latin: basic + extended + punctuation/digits
  const latinRegex = /^[\u0000-\u024F\s\d\p{P}]*$/u;

  if (japaneseRegex.test(str)) return 'NotoSansJP';
  if (koreanRegex.test(str)) return 'NotoSansKR';
  if (chineseRegex.test(str)) return 'NotoSansCH_Simplified';
  if (latinRegex.test(str)) return 'Roboto';

  // fallback to a universal font if unsure
  return 'Roboto';
}
